<template>
  <div style="display: grid; grid-template-rows: 1fr auto; height: 100vh">
    <div v-if="stepLogin === 0">
      <b-container class="mt-10">
        <b-row>
          <b-col sm class="text-center">
            <img alt="Logo" src="../../assets/logo.png" class="h-150px my-9"/>
          </b-col>
        </b-row>
      </b-container>
      <div class="container card_container mx-auto spid">
        <b-col class="mb-2">
              <span class="text-primary"><i class="fas fa-user"></i> <span
                  style="margin-top: 3px; margin-left: 4px; position: absolute">Autenticazione</span></span>
        </b-col>
        <b-tabs content-class="my-6" fill>
          <b-tab active title="SPID/CIE">
            <b-container class="bv-example-row">
              <b-row class="mt-7">
                <b-col sm class="mb-10">
                  <b-row class="justify-content-center">
                    <a href="#" class="italia-it-button italia-it-button-size-m button-spid"
                       spid-idp-button="#spid-idp-button-medium-get" @click="onAccediSpid">
                <span class="italia-it-button-icon"
                ><img src="../../assets/spid-ico-circle-bb.svg"
                      onerror="this.src='img/spid-ico-circle-bb.png'; this.onerror=null;" alt=""
                /></span>
                      <span class="italia-it-button-text">Entra con SPID/CIE</span>
                    </a>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm class="text-center">
                  <img alt="Logo" src="../../assets/loghi.png"/>
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab title="CNS">
            <b-container class="bv-example-row">
              <b-row>
                <b-col>
                  <p style="text-align: justify">
                    La Carta Nazionale dei Servizi (CNS) è una smart card o una chiavetta USB che contiene un “certificato digitale” di autenticazione personale, utile per accedere ai servizi online della Pubblica Amministrazione.
                    Per accedere hai bisogno di una CNS attiva, di una postazione che ne permetta la lettura e dei driver forniti dall'Amministrazione emittente.
                  </p>
                </b-col>
              </b-row>
              <b-row class="mt-7">
                <b-col class="mb-10">
                  <a :href="linkInfoCns" target="_blank" class="link-primary text-primary"> Maggiori informazioni su
                    CNS</a>
                </b-col>
                <b-col sm class="mb-10">
                  <a href="#" class="italia-it-button italia-it-button-size-m button-spid"
                     spid-idp-button="#spid-idp-button-medium-get" @click="onAccediCns">
                <span class="italia-it-button-icon"
                ><img src="../../assets/sign-in.png"
                      onerror="this.src='img/spid-ico-circle-bb.png'; this.onerror=null;" alt=""
                /></span>
                    <span class="italia-it-button-text">Entra con CNS</span>
                  </a>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm class="text-center">
                  <img alt="Logo" src="../../assets/loghi.png"/>
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
        </b-tabs>
        <b-row>
          <b-col sm class="mt-10 text-center">
            <p>Problemi con l'accesso?<a href="/contattaci" class="link-primary text-primary"> Contattaci</a></p>
          </b-col>
<!--          <b-col sm class="mt-10 text-center" v-if="true">-->
<!--            <p>Problemi con l'accesso?<button @click="loginDemo" class="link-primary text-primary"> LoginDemo</button></p>-->
<!--          </b-col>-->
        </b-row>
      </div>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots"
               :height="120" :width="120"></loading>
    </div>
    <div v-else-if="stepLogin === 1">
      <oauth-redirect @setStep="setStep" @getJsonData="getJsonData"></oauth-redirect>
    </div>
    <div>
      <div class="footer2">
        <p class="text-center"><img alt="molise salute" width="280px" src="../../assets/salute.svg"/></p>
      </div>
    </div>
  </div>

</template>
<script>
import Loading from "vue-loading-overlay";
import OauthRedirect from "../temp/oauthRedirect.vue";
import authService from "../../services/authService";
import utilService from "../../services/utilService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";
import OAuth2Handler from "../../../oidcAuth/oidcLogin";

export default {
  components: {Loading, OauthRedirect},
  data() {
    return {
      data: {},
      isLoading: false,
      strength: 0,
      stepLogin: 0,
      jsonData: {},
      user: null,
      linkInfoSpid: "https://www.spid.gov.it/",
      linkInfoCie: "https://www.cartaidentita.interno.gov.it/",
      linkInfoCns: "https://sistemats1.sanita.finanze.it/portale/it/web/guest/tessera-sanitaria-cittadini"
    };
  },
  async beforeMount() {
    const responseVocabolario = await utilService.Vocabolario();
    if (responseVocabolario.data.errore) {
      await this.$bvModal
          .msgBoxOk("Servizio momentaneamente non disponibili", {
            title: "Attenzione",
            size: "sm",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
      const arrayJSON = JSON.stringify(responseVocabolario.data.data.map(x => {
        return {nome: x.nome, messaggio: x.messaggio}
      }));
      sessionStorage.setItem('vocabolario', arrayJSON)
    }
  },
  methods: {
    onAccediSpid() {
      let me = this;
      me.isLoading = true;
      const oAuth2Handler = new OAuth2Handler()
      window.location = oAuth2Handler.getAuthorizationUrl()
      me.isLoading = false;
    },
    async loginDemo() {
      let me = this;
      me.isLoading = true;
      const response = await authService.loginDemo()
      if (!response.data.error) {
        let user = response.data.data;
        let me = this;
        try {
          console.log(user)
          me.isLoading = false;
          try {
            const responseTokenApi = await authService.tokenApi();
            sessionStorage.setItem("apiToken", responseTokenApi.data.data.access_token);
            if (response.data.stato === 200 || response.data.stato === 201) {
              me.isLoading = false;
              sessionStorage.setItem(
                  "messaggiUtente",
                  JSON.stringify({
                    messaggioPrePagamento: response.data.data.messaggioPrePagamento,
                    messaggioPrePrenotazione: response.data.data.messaggioPrePrenotazione,
                    piuReparti: response.data.data.piu_reparti,
                    preAnnullamento: response.data.data.pre_annullamento,
                  })
              );
              sessionStorage.setItem("loginData", response.data.data.token);
              sessionStorage.setItem(
                  "serviziAttivi",
                  JSON.stringify({
                    prenotazionePending: response.data.data.prenotazionePending,
                    loginStruttura: response.data.data.loginStruttura,
                    visualizzaTermini: response.data.data.visualizzaTermini,
                    contattiIsEnable: response.data.data.contattiIsEnable,
                    servizioIsEnable: response.data.data.servizioIsEnable,
                    pagamentiIsEnable: response.data.data.pagamentiIsEnable,
                    refertiIsEnable: response.data.data.refertiIsEnable,
                    prenotazioneIsEnable: response.data.data.prenotazioneIsEnable,
                    appuntamentiIsEnable: response.data.data.appuntamentiIsEnable,
                    cambioOperatoreIsEnable: response.data.data.cambioOperatoreIsEnable,
                    screening: response.data.data.screening,
                  })
              );
              if (response.data.data.servizioIsEnable) {
                me.$router.push({
                  name: "Prenota",
                  query: { authToken: response.data.access_token },
                });
              } else {
                let msg = getVocabolario("serverIndisponibile")
                if(!msg)
                  msg = "Il servizio non è al momento disponibile"
                this.$bvModal
                    .msgBoxOk(msg, {
                      title: "Attenzione!",
                      size: "sm",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {
                      me.$router.push("/");
                    });
              }
            }
          } catch (e) {
            console.log(e);
          }
        }catch (e){
          console.log(e)
        }
      }
      me.isLoading = false;
    },
    setStep(step) {
      let me = this;
      console.log(step);
      me.stepLogin = step;
    },
    getJsonData(value) {
      let me = this;
      me.jsonData = value;
    },
  },
};
</script>
<style scoped>
@import "../../assets/custom/style.css";


.nav-tabs {
  background-color: #FFFFFF !important;
}

.italia-it-button {
  display: inline-block;
  position: relative;
  padding: 0;
  color: #fff;
  font-family: "Titillium Web", HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
  font-weight: 600;
  line-height: 1em;
  text-decoration: none;
  border: 0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.italia-it-button-icon,
.italia-it-button-text {
  display: block;
  float: left;
}

.italia-it-button-icon {
  margin: 0 -0.4em 0 0;
  padding: 0.6em 0.8em 0.5em;
  border-right: rgba(255, 255, 255, 0.1) 0.1em solid;
}

.italia-it-button-text {
  padding: 0.95em 1em 0.85em 1em;
  font-size: 1.15em;
  text-align: center;
}

svg {
  width: 1.8em;
  height: 1.8em;
  fill: #fff;
}
.italia-it-block {
  display: block;
}

a:link { text-decoration: none; }

a:visited { text-decoration: none; }

a:hover { text-decoration: none; }

a:active { text-decoration: none; }

.italia-it-button-size-s {
  font-size: 10px;
  width: 150px;
}

.italia-it-button-size-s > span img {
  width: 19px;
  height: 19px;
  border: 0;
}

.italia-it-button-size-m {
  font-size: 15px;
  width: 250px;
}

.italia-it-button-size-m > span img {
  width: 29px;
  height: 29px;
  border: 0;
}

.button-spid {
  background-color: #186292;
  color: #fff;
}

.button-spid svg {
  fill: #fff;
}

.button-spid:hover {
  background-color: #334663;
  color: #fff;
}

.button-spid:active {
  background-color: #83beed;
  color: #186292;
}

.spid-idp-button {
  position: absolute;
  z-index: 1039;
  display: none;
}
</style>
